import { v4 as uuidv4 } from 'uuid';

export const LOGICFILESTATUSES =
{
  unknown: "unknown",
  equal: "equal",
  fromOnly: "fromOnly",
  toOnly: "toOnly",
  fromNewer: "fromNewer",
  toNewer: "toNewer",
  fromProcUpd: "fromProcUpd",
}

export const LOGICFILEORIGINS =
{
  metatool: 0,
  manual: 1
}

export const LOGICFILEPUBLISHSTATE =
{
  draft: 0,
  published: 1,
}

export const FILEDEPENDENCYTYPE =
{
    customer: 0,
    group: 1,
    environment: 2
}

export const SERVERFILETYPE =
{
    fontTrueType: 0,
    fontConfig: 1,
    license: 2,
    printConfig: 3,
    ICCProfile: 4,
    lexars: 5,
    logic: 6,
    backup: 7
}

export const getFileTypeName = (fileType) => {
  switch (fileType) {
    case SERVERFILETYPE.fontTrueType: 
      return "Font file";
    case SERVERFILETYPE.fontConfig: 
      return "Font config file";
    case SERVERFILETYPE.license:
      return "License file";
    case SERVERFILETYPE.printConfig: 
      return "Print config file";
    case SERVERFILETYPE.ICCProfile: 
      return "ICC profile file";
    case SERVERFILETYPE.lexars: 
      return "Lexars file";
    case SERVERFILETYPE.logic: 
      return "Logic file";
    case SERVERFILETYPE.backup: 
      return "Server Backup file";
  }

  return "Unknown filetype";
}

export const getFileTypeExt = (fileType) => {
  switch (Number(fileType)) {
    case SERVERFILETYPE.fontTrueType: 
      return ".ttf";
    case SERVERFILETYPE.fontConfig: 
      return ".xml";
    case SERVERFILETYPE.license:
      return ".xml";
    case SERVERFILETYPE.printConfig: 
      return ".xml";
    case SERVERFILETYPE.ICCProfile: 
      return ".icm";
    case SERVERFILETYPE.lexars: 
      return ".xml";
    case SERVERFILETYPE.logic: 
      return ".mfl";
    case SERVERFILETYPE.backup: 
      return ".zip";
  }

  return "Unknown filetype";
}

export const mergeTemplatesAndProcessDates = (activeTplEnvironments, processDates) => {
  console.log("mergeTemplatesAndProcessDates", "activeTplEnvironments", activeTplEnvironments, "processDates", processDates);

  processDates.map(prsEnv => {
    var tplEnv = activeTplEnvironments.find(p => p.id === prsEnv.templateId);
    if (!!tplEnv)
    {
      prsEnv.files.map(prsFile => {
        var tplFile = tplEnv.files.find(f => f.id === prsFile.fileId);
        if (!!tplFile)
        {
          tplFile.lastProcessDate = prsFile.lastUpdated;
          console.log("mergeTemplatesAndProcessDates", "tplFile", tplFile);
        }
      })
    }
  });  
}

export const hasUpdatableStatus = (fileStatus) => {
  const status = fileStatus.status;
  return status === LOGICFILESTATUSES.fromNewer || status === LOGICFILESTATUSES.fromOnly || status === LOGICFILESTATUSES.fromProcUpd;
}

export const hasInvalidStatus = (fileStatus) => {
  const status = fileStatus.status;
  return status === LOGICFILESTATUSES.toNewer || status === LOGICFILESTATUSES.toOnly;
}

export const getInvalidStatusMessage = (fileStatus) => {
  switch (fileStatus.status)
  {
  case LOGICFILESTATUSES.toNewer:
    return "File is older";
  case LOGICFILESTATUSES.toOnly:
    return "File missing";
  }
  return undefined;
}

export const getFileStatusesBetweenTemplates = (fromTemplate, toTemplate, onAddStatus, doSort = true) => {
  console.log("getFileStatusesBetweenTemplates", "fromTemplate", fromTemplate, "toTemplate", toTemplate);

  const validTimeSpan = new Date(1000 * 60 * 1).getTime(); // 1 minute(s)
  // Add files from FROM first
  let fileStatus = fromTemplate
    ? fromTemplate.files.map((fromFile) => {
      const toFile = toTemplate.files.find(({fileName}) => fileName === fromFile.fileName);

      let status = LOGICFILESTATUSES.unknown;

      var toDate = toFile ? new Date(toFile.fileDate).getTime() : 0;
      var fromDate = new Date(fromFile.fileDate).getTime();
      var fromProcessDate = !!fromFile.lastProcessDate ? new Date(fromFile.lastProcessDate).getTime() : 0;
      var fromLastProcessUpdate = !!fromFile.lastProcessUpdate ? new Date(fromFile.lastProcessUpdate).getTime() : 0;
      var toProcessDate = !!toFile?.lastProcessDate ? new Date(toFile.lastProcessDate).getTime() : 0;
      var toLastProcessUpdate = !!toFile?.lastProcessUpdate ? new Date(toFile.lastProcessUpdate).getTime() : 0;

      const timeDiff = toDate ? toDate - fromDate : 0;
      const timeDiffProc = fromLastProcessUpdate && fromProcessDate ? fromProcessDate - fromLastProcessUpdate : 0;
      const timeDiffProcToFrom = fromLastProcessUpdate && toLastProcessUpdate ? fromLastProcessUpdate - toLastProcessUpdate : 0;

      console.log("getFileStatusesBetweenTemplates", "toProcessDate", toProcessDate, "toLastProcessUpdate", toLastProcessUpdate, "timeDiffProcToFrom", timeDiffProcToFrom, "validTimeSpan", validTimeSpan, fromFile.lastProcessUpdate, toFile?.lastProcessUpdate);

      // console.log("getFileStatusesBetweenTemplates", "fromFile.fileName", fromFile.fileName);
      // console.log("getFileStatusesBetweenTemplates", "timeDiff", timeDiff, "toDate", toDate, "fromDate", fromDate, toFile?.fileDate, fromFile.fileDate);
      // console.log("getFileStatusesBetweenTemplates", "timeDiffProc", timeDiffProc, "fromProcessDate", fromProcessDate, "fromLastProcessUpdate", fromLastProcessUpdate, "fromFile.lastProcessDate", fromFile.lastProcessDate, "fromFile.lastProcessUpdate", fromFile.lastProcessUpdate);

      if (!toFile)
        status = LOGICFILESTATUSES.fromOnly;
      else if (timeDiff === 0)
        status = LOGICFILESTATUSES.equal;
      else if (timeDiff < 0)
        status = LOGICFILESTATUSES.fromNewer;
      else if (timeDiff > 0)
        status = LOGICFILESTATUSES.toNewer;
      
      if (((timeDiffProc === undefined && fromProcessDate !== null) || timeDiffProc !== 0 || timeDiffProcToFrom > 0) && (status === LOGICFILESTATUSES.unknown || status === LOGICFILESTATUSES.equal)) {
        status = LOGICFILESTATUSES.fromProcUpd;
        console.log("getFileStatusesBetweenTemplates", "setting status from timeDiffProc", status, fromFile.id, fromFile.fileName, timeDiffProc, (timeDiffProc === undefined && fromProcessDate !== null) || timeDiffProc > 0);
      }

      // if (status !== LOGICFILESTATUSES.unknown && status !== LOGICFILESTATUSES.equal)
      //   console.log("### getFileStatusesBetweenTemplates", "status", status, fromFile.id, fromFile.fileName, timeDiff, timeDiffProc);

      var fileStatusData = { id: uuidv4(), fileName: fromFile.fileName, from: fromFile, to: toFile, status: status };
      if (onAddStatus)
        onAddStatus(fileStatusData);

      console.log("getFileStatusesBetweenTemplates", "fileStatusData", fileStatusData);
      return fileStatusData;
    })
    : [];

  // Add missing files from TO (should be none)
  toTemplate.files.map((toFile) => {
    const file = fileStatus.find((x) => x.fileName === toFile.fileName);
    if (!file)
    {
      var fileStatusData = { id:uuidv4(), fileName: toFile.fileName, from: undefined, to: toFile, status: LOGICFILESTATUSES.toOnly };
      if (onAddStatus)
        onAddStatus(fileStatusData);

      fileStatus.push(fileStatusData)
    }
  });

  return !doSort 
    ? fileStatus 
    : fileStatus.sort((a, b) => {
        if (a.from && b.from)
        {
          var dateA = Date.parse(a.from.fileDate), dateB = Date.parse(b.from.fileDate);
          return dateB - dateA;
        }
        if (!a.from && !b.from && a.to && b.to)
        {
          var dateA = Date.parse(a.to.fileDate), dateB = Date.parse(b.to.fileDate);
          return dateB - dateA;
        }
      });
}